module.exports = __webpack_public_path__ + "static/img/thaikau.1e6cf027.png";